import React, { forwardRef, memo } from 'react'

const CameraIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="34.3"
      height="34.3"
      viewBox="0 0 34.3 34.3"
      fill="none"
      {...props}>
      <circle
        cx="17.306"
        cy="17.396"
        r="4.2"
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.607"
        y="8.996"
        width="29.4"
        height="16.8"
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.007 14.246a8.2 8.2 0 0 1-5.251-5.251M26.756 25.796a8.2 8.2 0 0 1 5.251-5.251M2.607 20.545a8.2 8.2 0 0 1 5.251 5.251M7.858 8.995a8.2 8.2 0 0 1-5.251 5.251"
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

CameraIcon.displayName = 'CameraIcon'

export default memo(CameraIcon)
